import { twMerge } from "tailwind-merge";
import { H5, H6 } from "../Header";

export const CheckboxListItem = ({
  title,
  subtitle,
  onClick,
  className,
  checked,
}: {
  title: string;
  subtitle?: string;
  onClick: () => void;
  className?: string;
  checked: boolean;
}) => {
  return (
    <div
      className={twMerge("flex flex-row justify-between p-4", className)}
      onClick={onClick}
    >
      <div className="flex flex-col">
        <H5>{title}</H5>
        {subtitle && <H6>{subtitle}</H6>}
      </div>
      <input checked={checked} readOnly type="checkbox" />
    </div>
  );
};
